import { useState, useEffect } from 'react'

/**
 * SSR 호환 mount 감지 훅.
 *
 * 첫 렌더(서버 + 클라이언트 첫 렌더)는 항상 false 반환 → 하이드레이션 매치.
 * useEffect로 mount 후 true로 업데이트 → 클라이언트 전용 콘텐츠 렌더.
 *
 * 사용 예: SSR 페이지에서 인증 상태에 따라 다른 UI를 보여줄 때
 *
 * ```tsx
 * const hasMounted = useHasMounted()
 * const isAuthenticated = useAuthStore(s => s.isAuthenticated)
 * return hasMounted && isAuthenticated ? <UserMenu /> : <LoginButton />
 * ```
 */
export function useHasMounted(): boolean {
  const [mounted, setMounted] = useState(false)
  useEffect(() => {
    setMounted(true)
  }, [])
  return mounted
}
